import { getUrlEnvironmentSegment } from './service-url'

const SERVO_PRODUCTION_BASE_URL = 'https://console.instadmin.net/servo'
const SERVO_STAGING_BASE_URL = 'https://instadmin-console.apps-euw3.platform.staging.ibx.dev/servo'

export const getServoBaseUrl = () =>
    getUrlEnvironmentSegment() === 'testing.' ? SERVO_STAGING_BASE_URL : SERVO_PRODUCTION_BASE_URL

/**
 * @param {string} orderToken The order token, e.g. "o3780dpgn".
 * @param {string|number} packageId The parcel's package id, e.g. "473501541802529604"
 * @returns {string|null} The Servo order URL, or null when the order token is missing.
 */
export const buildServoOrderUrl = (orderToken, packageId) => {
    if (!orderToken) {
        return null
    }

    return `${getServoBaseUrl()}/orders/${orderToken}:${packageId}`
}
